// Module
var code = `<div class="jumbotron small"> <h2>Your session has expired</h2> <p>Please logout and then login again.</p> <a ng-click="expiredController.logout()" class="btn btn-primary">Logout</a> </div> `;
// Exports
module.exports = code;